var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBankDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99993 4.0002C7.19884 4.0002 7.38961 3.92119 7.53026 3.78053C7.67091 3.63988 7.74993 3.44912 7.74993 3.2502C7.74993 3.05129 7.67091 2.86052 7.53026 2.71987C7.38961 2.57922 7.19884 2.5002 6.99993 2.5002C6.80102 2.5002 6.61025 2.57922 6.4696 2.71987C6.32895 2.86052 6.24993 3.05129 6.24993 3.2502C6.24993 3.44912 6.32895 3.63988 6.4696 3.78053C6.61025 3.92119 6.80102 4.0002 6.99993 4.0002ZM7.73593 0.455203C7.5279 0.286137 7.268 0.193848 6.99993 0.193848C6.73186 0.193848 6.47196 0.286137 6.26393 0.455203L1.26193 4.5202C0.653929 5.0162 1.00393 6.0002 1.78793 6.0002H1.99993V10.2002C1.40593 10.5032 0.999929 11.1202 0.999929 11.8332V12.5002C0.999929 12.6328 1.05261 12.76 1.14638 12.8538C1.24014 12.9475 1.36732 13.0002 1.49993 13.0002H12.4999C12.6325 13.0002 12.7597 12.9475 12.8535 12.8538C12.9473 12.76 12.9999 12.6328 12.9999 12.5002V11.8332C12.9999 11.1212 12.5939 10.5032 11.9999 10.2002V6.0002H12.2119C12.9959 6.0002 13.3459 5.0152 12.7369 4.5202L7.73693 0.454203L7.73593 0.455203ZM6.89593 1.2312C6.92565 1.20717 6.96271 1.19406 7.00093 1.19406C7.03915 1.19406 7.07621 1.20717 7.10593 1.2312L11.7409 5.0002H2.25793L6.89593 1.2312ZM10.9999 10.0002H9.99993V6.0002H10.9999V10.0002ZM8.99993 10.0002H7.49993V6.0002H8.99993V10.0002ZM6.49993 10.0002H4.99993V6.0002H6.49993V10.0002ZM11.1669 11.0002C11.6269 11.0002 11.9999 11.3732 11.9999 11.8332V12.0002H1.99993V11.8332C1.99993 11.3732 2.37293 11.0002 2.83293 11.0002H11.1669ZM3.99993 10.0002H2.99993V6.0002H3.99993V10.0002Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDetails);
export default __webpack_public_path__ + "static/media/bank-details.66e5899d66f4fe9145ea97d1896c1891.svg";
export { ForwardRef as ReactComponent };